export enum ParameterEnum {
  Name = 'name',
  Path = 'path',
  Ext = 'ext',
  //
  FieldClass = 'fieldClass',
  //
  WeekStart = 'week_start',
  DefaultTimezone = 'default_timezone',
  AllowTimezones = 'allow_timezones',
  CaseSensitiveStringFilters = 'case_sensitive_string_filters',
  //
  AccessRoles = 'access_roles',
  As = 'as',
  BuildMetrics = 'build_metrics',
  Connection = 'connection',
  CurrencyPrefix = 'currency_prefix',
  CurrencySuffix = 'currency_suffix',
  ThousandsSeparator = 'thousands_separator',
  Dashboard = 'dashboard',
  Dimension = 'dimension',
  Description = 'description',
  Fields = 'fields',
  Filter = 'filter',
  MaxFractions = 'max_fractions',
  Required = 'required',
  Meta = 'meta',
  Controls = 'controls',
  FractionControls = 'fraction_controls',
  Fractions = 'fractions',
  Logic = 'logic',
  ApplyTo = 'apply_to',
  FormatNumber = 'format_number',
  Formula = 'formula',
  TimeGroup = 'time_group',
  Group = 'group',
  GroupLabel = 'group_label',
  GroupDescription = 'group_description',
  Hidden = 'hidden',
  HideFields = 'hide_fields',
  Label = 'label',
  TopLabel = 'top_label',
  TreeDoubleUnderscore = 'tree_double_underscore',
  Limit = 'limit',
  Listen = 'listen',
  Measure = 'measure',

  Model = 'model',
  MproveDir = 'mprove_dir',
  Percentile = 'percentile',
  Report = 'report',
  Space = 'space',
  Tiles = 'tiles',
  Result = 'result',
  FractionTypes = 'fraction_types',
  Folders = 'folders',
  SuggestModelDimension = 'suggest_model_dimension',
  Rows = 'rows',
  Query = 'query',
  Select = 'select',

  Input = 'input',
  ListInput = 'list_input',
  Switch = 'switch',
  DatePicker = 'date_picker',
  Selector = 'selector',
  Value = 'value',

  ShowFields = 'show_fields',
  Sorts = 'sorts',
  Time = 'time',
  Detail = 'detail',
  Unit = 'unit',
  Timeframes = 'timeframes',
  Title = 'title',
  Type = 'type',

  Mod = 'mod',
  Location = 'location',

  Store = 'store',
  StoreModel = 'store_model',
  StoreFilter = 'store_filter',
  StoreResult = 'store_result',
  Method = 'method',
  Preset = 'preset',
  Request = 'request',
  Response = 'response',
  Results = 'results',
  DateRangeIncludesRightSide = 'date_range_includes_right_side',
  FieldGroups = 'field_groups',
  FieldTimeGroups = 'field_time_groups',
  Chart = 'chart',
  // row
  Parameters = 'parameters',
  RowId = 'row_id',
  Metric = 'metric',
  ShowChart = 'show_chart',
  // parameter
  Conditions = 'conditions',
  // chart axis
  Data = 'data',
  Options = 'options',
  Plate = 'plate',
  // chart data
  XField = 'x_field',
  YFields = 'y_fields',
  SizeField = 'size_field',
  MultiField = 'multi_field',
  PivotRows = 'pivot_rows',
  PivotColumns = 'pivot_columns',
  PivotValues = 'pivot_values',
  Field = 'field',
  Aggregate = 'aggregate',
  // chart options
  Format = 'format',
  Pivot = 'pivot',
  ShowTotals = 'show_totals',
  ShowGrandTotal = 'show_grand_total',
  DefaultExpanded = 'default_expanded',
  ShowMenu = 'show_menu',
  Theme = 'theme',
  FirstColumnWidth = 'first_column_width',
  ValueColumnsWidth = 'value_columns_width',
  XAxis = 'x_axis',
  YAxis = 'y_axis',
  Series = 'series',
  // x_axis, y_axis
  Scale = 'scale',
  // series
  DataField = 'data_field',
  DataRowId = 'data_row_id',
  YAxisIndex = 'y_axis_index',
  // chart plate
  PlateWidth = 'plate_width',
  PlateHeight = 'plate_height',
  PlateX = 'plate_x',
  PlateY = 'plate_y',
  //
  Relationships = 'relationships',
  Schema = 'schema',
  Table = 'table',
  Tables = 'tables',
  Column = 'column',
  Columns = 'columns',
  Example = 'example',
  CacheUniqueValues = 'cache_unique_values',
  To = 'to',
  ToSchema = 'to_schema'
}
